import { FacebookAuthProvider } from 'firebase/auth';
import { NativeSignInPage } from './NativeSignInPage';

function createProvider() {
  const provider = new FacebookAuthProvider();
  provider.addScope('email');
  provider.addScope('public_profile');
  return provider;
}

function FacebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.469H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z"
      />
    </svg>
  );
}

const idleIcon = (
  <svg viewBox="0 0 24 24" className="size-10" aria-hidden>
    <path
      fill="#1877F2"
      d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.469H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z"
    />
  </svg>
);

/**
 * `/auth/native-facebook-signin` route.
 *
 * Opened by the React Native app in the system browser to work around Facebook
 * OAuth failing inside WebViews.
 */
export function NativeFacebookSignInPage() {
  return (
    <NativeSignInPage
      appName="native-facebook-signin"
      providerLabel="Facebook"
      createProvider={createProvider}
      buttonClassName="bg-[#1877F2]"
      buttonIcon={<FacebookIcon />}
      idleIcon={idleIcon}
      idleGlowClass="bg-[#1877F2]/30"
      idleBorderClass="border-[#1877F2]/30"
      idleBgClass="bg-[#1877F2]/5"
      loadingSpinnerClass="text-[#1877F2]"
    />
  );
}
